import React from 'react';

const StepWrapper: React.FC<{ show: boolean; children: React.ReactNode }> = ({
  show,
  children,
}) => <div style={{ display: show ? 'block' : 'none' }}>{children}</div>;

export default StepWrapper;
